






































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Native from "@/common/Native";
import request from "@/api/yunyang/index";
import { IuserInfo, ICommentsItem, ITopicDetail } from "@/api/yunyang/types";
import { Image as vanImage, Lazyload, List as vanList, Dialog } from "vant";
import AppPrompt from "@/components/AppPrompt.vue";
import indexRequest from "@/api/index";
import Base from "@/template/public/Base.vue";
import { wxChatShare } from "@/common/wechat";
Vue.use(Lazyload, {});
@Component({
  components: {
    vanImage,
    AppPrompt,
    vanList
  }
})
export default class saledetail extends Base {
  isOpenInApp: boolean = false;
  id: string = "";
  appId: string = "";
  userInfo: IuserInfo = { phone: "", sessionId: "", token: "" };
  detail: ITopicDetail = {
    imgs: "",
    momentsTopicNames: ""
  };
  comments: Array<ICommentsItem> = [];

  private isRequestLoaded: boolean = false; //详情是否加载完成
  private isLoading: boolean = false;
  private loading: boolean = false;
  private finished: boolean = false;
  private lastCreateTime: string = "";
  private lastReplyId?: number | string;
  public request: any = new indexRequest();
  mounted() {
    this.appId = (this.$route.query.appId as string) || "";
    this.isOpenInApp = ZWY_CLOUD.isOpenInApp();
    this.id = (this.$route.query.id as string) || "";
    this.getShareInfo(this.appId);
    Native.getUserInfo().then((res: IuserInfo) => {
      this.userInfo = res;
      this.getSquareDetail().then(() => {
        this.isRequestLoaded = true;
        // this.getComments();
      });
    });

    // 微信配置
    wxChatShare(
      this.detail.userNickname,
      this.detail.content,
      window.location.href,
      this.detail.userAvatar
    );
  }
  getSquareDetail() {
    let data = {
      id: this.id,
      appId: this.appId,
      sessionId: this.userInfo.sessionId,
      token: this.userInfo.token,
      isOpenApp: "true",
      vfrom: "1"
    };
    return request.squareDetail(data).then(res => {
      if (res.code >= 0) {
        this.detail = res.data;
        this.comments = res.data.commentsDatas;
      }
    });
  }
  doSome(item: any) {
    Dialog.alert({
      message: "请前往下载" + this.shareInfo.appName + "客户端！",
      closeOnClickOverlay: true
    }).then(() => {
      // on close
      // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
      // window.location.href = this.downloadUrl;
      this.openApp(item);
    });
  }
  onLoad() {}
  // getComments(isClear = true) {
  //   if (isClear) {
  //     // 如果要清除所有，重新加载，需要重置到第一页
  //     this.lastCreateTime = "";
  //     this.lastReplyId = "";
  //   }
  //   let data = {
  //     appId: this.appId,
  //     sourceId: this.id,
  //     sourceType: 4,
  //     lastReplyId: this.lastReplyId,
  //     lastCreateTime: this.lastCreateTime,
  //     sessionId: this.userInfo.sessionId,
  //     token: this.userInfo.token
  //   };
  //   return request.comments(data).then((res: any) => {
  //     if (res.code >= 0) {
  //       if (isClear) {
  //         this.comments = [];
  //       }
  //       if (res.data.news.length === 0) {
  //         this.finished = true;
  //       }
  //       this.comments = this.comments.concat(res.data.dataList);
  //       this.isLoading = false;
  //       this.loading = false;
  //       this.lastCreateTime = res.data.dataList.lastChild.createTime as string;
  //       this.lastReplyId = res.data.dataList.lastChild.replyId;
  //     }
  //   });
  // }

  // 去掉#
  removeCharacter(str: string | undefined) {
    return str ? str.replace(/#/g, "") : "";
  }
}
